import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  breadCrumb: [],
  selectedHospitalType: "all",
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setBreadCrumb(state, action) {
      state.breadCrumb = action.payload;
    },
    setSelectedHospitalType(state, action) {
      state.selectedHospitalType = action.payload;
    },
  },
});

export const { setBreadCrumb, setSelectedHospitalType } = commonSlice.actions;
export default commonSlice.reducer;
